// components
import PageHeader from '@layout/PageHeader';
import AppGrid from '@layout/AppGrid';
import MatchesSegmentChart from '@widgets/MatchesSegmentChart';
import LiveMatches from '@widgets/LiveMatches';
import TeamStatsSlider from '@widgets/TeamStatsSlider';
import MonthMatches from '@widgets/MonthMatches';
import MatchResultColor from '@widgets/MatchResultColor';
import Matches from "@pages//RefMatches";

const widgets = {
    month_matches: <Matches />,
}

const MatchesOverview = () => {
    return (
        <>
            <PageHeader title="Spielplan Übersicht" />
            <AppGrid id="matchesOverview" widgets={widgets} />
        </>
    )
}

export default MatchesOverview